import { render, staticRenderFns } from "./Proyectos-Tecnologias.vue?vue&type=template&id=4be3c4b8&scoped=true"
import script from "./Proyectos-Tecnologias.vue?vue&type=script&lang=js"
export * from "./Proyectos-Tecnologias.vue?vue&type=script&lang=js"
import style0 from "./Proyectos-Tecnologias.vue?vue&type=style&index=0&id=4be3c4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be3c4b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VContainer,VContent,VDataTable,VIcon,VTextField})
